import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import Router from "./Routing";
import store from "./store";
import Loader from "./Components/Loader";
import setInitAppSettings from "./store/initAppSettings";

setInitAppSettings();

const App = () => (
    <BrowserRouter>
        <Provider store={store}>
            <Loader>
                <Router/>
            </Loader>
        </Provider>
    </BrowserRouter>
);

export default App;
